import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function Services() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  return (
    <Box>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>AI Consulting Services</title>
        <meta name="description" content="Overview of our AI readiness, policy, consulting and assessment services." />
        <meta property="og:title" content="AI Consulting Services" />
        <meta property="og:description" content="Explore our range of pragmatic AI services and offerings." />
        <meta property="og:image" content="/assets/visuals/re-profile-orange-ai-hud.webp" />
      </Helmet>
      <Typography variant="h4" component="h1" gutterBottom>Services</Typography>

      <Box mb={3}>
        <Typography variant="h6" component="h2">AI Readiness Assessment</Typography>
        <Typography paragraph>
          Helping organisations build the foundations for successful, sustainable AI adoption.
        </Typography>
        <MuiLink component={Link} to="/services/ai-readiness-assessment">
          Learn more: AI Readiness Assessment
        </MuiLink>
      </Box>

      <Box mb={3}>
        <Typography variant="h6" component="h2">Rapid AI Automation Sprint</Typography>
        <Typography paragraph>
          Turning one high-friction workflow into a working AI-assisted prototype in days, not months.
        </Typography>
        <MuiLink component={Link} to="/services/rapid-ai-automation-sprint">
          Learn more: Rapid AI Automation Sprint
        </MuiLink>
      </Box>

      <Box mb={3}>
        <Typography variant="h6" component="h2">AI Policy Development</Typography>
        <Typography paragraph>
          Establishing robust, ethical and compliant AI governance frameworks tailored to your organisation.
        </Typography>
        <MuiLink component={Link} to="/services/ai-policy-development">
          Learn more: AI Policy Development
        </MuiLink>
      </Box>

      <Box mb={3}>
        <Typography variant="h6" component="h2">End-to-End AI Consulting</Typography>
        <Typography paragraph>
          Transforming your toughest challenges into scalable AI solutions, from strategy through production.
        </Typography>
        <MuiLink component={Link} to="/services/end-to-end-ai-consulting">
          Learn more: End-to-End AI Consulting
        </MuiLink>
      </Box>

      <Box mb={3}>
        <Typography variant="h6" component="h2">Free AI Assessment</Typography>
        <Typography paragraph>
          AI capability &amp; use case discovery questionnaire with personalised report and follow-up call.
        </Typography>
        <MuiLink component={Link} to="/services/free-ai-assessment">
          Learn more: Free AI Assessment
        </MuiLink>
      </Box>
    </Box>
  );
}
